export default {"src":"/_next/static/media/edamame.0d58c7a8.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};